export const scrollTo = (scrollRef: string) => {
  const element = document.getElementById(scrollRef);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

export const scrollToImmediate = (scrollRef: string) => {
  const element = document.getElementById(scrollRef);
  if (element) {
    element.scrollIntoView(true);
  }
};